import { User, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts'
import appConfig from '../config'
import { setActiveAccessToken, setAxiosAuthHeader } from './AuthorizationHelpers'

const config: UserManagerSettings = {
  authority: appConfig.identityServer.authority,
  client_id: appConfig.identityServer.client_id,
  redirect_uri: `${window.location.origin}/login-redirect`,
  client_secret: appConfig.identityServer.clientSecret,
  scope: appConfig.identityServer.scope,
  response_type: 'code',
  post_logout_redirect_uri: `${window.location.origin}/login`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silentrenew.html`,
}
const configuration = new UserManager(config)

const getUserWhenLogin = async () => {
  let user
  const callback = await configuration.signinRedirectCallback()
  await configuration.getUser().then((userDetails: User) => {
    if (userDetails && !userDetails.expired) {
      user = userDetails
      setAxiosAuthHeader(userDetails.access_token)
      setActiveAccessToken(userDetails.access_token, userDetails.expires_at)
      if (callback.state) {
        user.state = callback.state
      }
    } else {
      configuration.signinRedirect()
    }
  })
  return user
}
const getUser = async () => {
  await configuration.clearStaleState()
  let user: User = null
  await configuration.getUser().then(userDetails => {
    if (userDetails && !userDetails.expired) {
      user = userDetails
    } else {
      configuration.signinRedirect({
        state: location.pathname,
      })
    }
  })
  configuration.startSilentRenew()
  return user
}

const renewToken = async () => {
  let user: User = null
  configuration.startSilentRenew()
  await configuration.getUser().then(userDetails => {
    if (userDetails && !userDetails.expired) {
      user = userDetails
    } else {
      configuration.signinRedirect({
        state: location.pathname,
      })
    }
  })
  return user
}

const signIn = () => {
  configuration.signinRedirect()
}

const signOut = async () => {
  await configuration.signoutRedirect()
  await configuration.signoutCallback()
}

const userManager = { configuration, getUserWhenLogin, signIn, getUser, renewToken, signOut }

export default userManager
